module.exports = __webpack_public_path__ + "static/media/tiny-manual-import-1.3db0aa8a.png";